import React, { useState, useEffect } from "react";
import * as S from "./styles";
import agente from "../../services/agents";
import _, { update } from "lodash";
import InputText from "../InputText";
import regional from "../../services/regional";
import convenio from "../../services/convenio";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { mask, unMask } from "../../utils/mask";
import { toast } from "react-toastify";

const AutoCompleteSearch = ({ handleSearch, initialValue, label, updated }) => {
  const [filtredValue, setFiltredValue] = useState("");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const handleOpen = () => {
    setOpen(!open);
  };

  const filterSearch = async (value) => {
    let errorMsgComplement = "";
    try {
      if (label === "Digite um novo CPF/CNPJ/Nome de agente para buscar...") {
        errorMsgComplement = "agente";
        const data = await agente.searchAgents(desmaskIfNumber(value));
        if (data?.data) {
          setItems(
            data?.data?.content?.map((item) => ({
              id: item?.id,
              cpfCnpj: item?.pessoa?.cpfCnpj,
              nome: item?.nomeAgente,
            }))
          );
        }
      } else if (
        label === "Digite um novo CPF/CNPJ/Nome de regional para buscar..."
      ) {
        errorMsgComplement = "regional";
        const data = await regional.searchRegionais(desmaskIfNumber(value));
        if (data?.data) {
          setItems(
            data?.data?.content?.map((item) => ({
              id: item?.id,
              cpfCnpj: item?.pessoa?.cpfCnpj,
              nome: item?.nomeRegional,
            }))
          );
        }
      } else if (
        label === "Digite um novo CPF/CNPJ/Nome de convênio para buscar..."
      ) {
        errorMsgComplement = "convênio";
        const data = await convenio.searchConvenios(desmaskIfNumber(value));
        if (data?.data) {
          setItems(
            data?.data?.content?.map((item) => ({
              id: item?.id,
              cpfCnpj: item?.pessoa?.cpfCnpj,
              nome: item?.nomeConvenio,
            }))
          );
        }
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar " + errorMsgComplement + ".");
      }
    }
  };

  const selection = (item) => {
    if (label === "Digite um novo CPF/CNPJ/Nome de agente para buscar...") {
      handleSearch(item, "AGENTE");
    } else if (
      label === "Digite um novo CPF/CNPJ/Nome de regional para buscar..."
    ) {
      handleSearch(item, "REGIONAL");
    } else if (
      label === "Digite um novo CPF/CNPJ/Nome de convênio para buscar..."
    ) {
      handleSearch(item, "CONVENIO");
    }

    setFiltredValue("");
    setOpen(false);
  };

  function handleFilter(e) {
    setFiltredValue(e.target.value);
    filterSearch(unMask(e.target.value || ""));

    if (e && e.target.value.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  useEffect(() => {
    setItems([]);
  }, [updated]);

  useEffect(() => {
    if (initialValue) {
      setFiltredValue(initialValue);
      handleSearch(initialValue);

      if (filtredValue.length > 3) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
  }, [initialValue]);

  return (
    <>
      <S.Wrapper>
        <S.Main>
          <S.Select onClick={handleOpen}>
            <InputText
              type="text"
              width="58%"
              label={label}
              onChange={(e) => handleFilter(e)}
              value={filtredValue}
              currency=""
            />
          </S.Select>
          {open && (
            <S.Options>
              {items?.map((item) => (
                <S.Option key={item.id} onClick={() => selection(item)}>
                  <S.Description>
                    {mask(item?.cpfCnpj, "##.###.###/####-##") +
                      " - " +
                      item?.nome}
                  </S.Description>
                </S.Option>
              ))}
            </S.Options>
          )}
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default AutoCompleteSearch;
